// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
// let commonUrl = "//super.peninsulaboutique8.com";
 let commonUrl = "https://art.cutting-edgexaitechnology.com";
let baseUrl = {
    commonUrl
}
 
export default baseUrl